<div class="product-costs-feature">
	<div class="product-costs-body">
		<div class="product-costs-top m-3">
			<div class="d-flex flex-wrap align-items-center gap-3">
				<div class="d-flex align-items-center gap-2" [formGroup]="rangeForm">
					<mat-form-field class="product-costs-date-field" subscriptSizing="dynamic" appearance="outline">
						<mat-label>Zakres dat</mat-label>
						<mat-date-range-input [rangePicker]="picker">
							<input matStartDate formControlName="start" placeholder="Od" />
							<input matEndDate formControlName="end" placeholder="Do" />
						</mat-date-range-input>
						<mat-hint>DD.MM.RRRR – DD.MM.RRRR</mat-hint>
						<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
						<mat-date-range-picker #picker></mat-date-range-picker>
					</mat-form-field>
				</div>
				<div class="ms-auto">
					<button mat-raised-button color="primary" (click)="openAddCostDialog()">
						<i class="fas fa-plus me-1"></i>
						Dodaj koszt
					</button>
				</div>
			</div>
		</div>

		<div class="dynamic-table">
			<mat-table class="w-100 product-costs-table" [dataSource]="productCosts()" multiTemplateDataRows>
				<ng-container matColumnDef="name">
					<mat-header-cell *matHeaderCellDef>Nazwa</mat-header-cell>
					<mat-cell *matCellDef="let productCost">{{ productCost.name }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="status">
					<mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
					<mat-cell *matCellDef="let productCost">
						<span
							class="badge fw-semibold"
							[class.text-bg-light]="productCost.status === 'current'"
							[class.text-bg-warning]="productCost.status === 'price_update'"
							[class.text-bg-info]="productCost.status === 'to_verify'"
							>{{ productCost.status | productCostStatusLabel }}</span
						>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="kind">
					<mat-header-cell *matHeaderCellDef>Rodzaj</mat-header-cell>
					<mat-cell *matCellDef="let productCost">{{ productCost.kind?.name }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="currency">
					<mat-header-cell *matHeaderCellDef>Waluta</mat-header-cell>
					<mat-cell *matCellDef="let productCost">{{ productCost.currency?.name }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="paymentMethod">
					<mat-header-cell *matHeaderCellDef>Metoda płatności</mat-header-cell>
					<mat-cell *matCellDef="let productCost">{{ productCost.paymentMethod?.name ?? '-' }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="method">
					<mat-header-cell *matHeaderCellDef>Metoda</mat-header-cell>
					<mat-cell *matCellDef="let productCost">{{ productCost.method | productCostMethodLabel }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="fixedCapacity">
					<mat-header-cell *matHeaderCellDef>X</mat-header-cell>
					<mat-cell *matCellDef="let productCost">{{ productCost.fixedCapacity ?? '-' }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="isFaculty">
					<mat-header-cell *matHeaderCellDef>Fakultet</mat-header-cell>
					<mat-cell *matCellDef="let productCost">{{ productCost.isFaculty ? 'Tak' : 'Nie' }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="note">
					<mat-header-cell *matHeaderCellDef>Uwagi</mat-header-cell>
					<mat-cell *matCellDef="let productCost">{{ productCost.note ?? '-' }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="actions">
					<mat-header-cell *matHeaderCellDef aria-label="Akcje">&nbsp;</mat-header-cell>
					<mat-cell *matCellDef="let productCost">
						<button
							mat-icon-button
							matTooltip="Zakresy i ceny"
							aria-label="Zakresy i ceny"
							color="primary"
							(click)="openManageCostDialog(productCost); $event.stopPropagation()"
						>
							<i class="fas fa-calendar-alt"></i>
						</button>
						<button
							mat-icon-button
							matTooltip="Edytuj dane kosztu"
							aria-label="Edytuj dane kosztu"
							color="primary"
							(click)="openEditCostDialog(productCost); $event.stopPropagation()"
						>
							<i class="fas fa-pencil-alt"></i>
						</button>
						<button
							mat-icon-button
							aria-label="Rozwiń wiersz"
							(click)="toggle(productCost); $event.stopPropagation()"
							class="product-costs-toggle-button"
							[class.product-costs-toggle-button-expanded]="isExpanded(productCost)"
						>
							<i class="fas fa-chevron-down"></i>
						</button>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="expandedDetail">
					<mat-cell *matCellDef="let productCost" [attr.colspan]="displayedColumns.length">
						<div
							class="product-costs-detail-wrapper w-100"
							[class.product-costs-detail-wrapper-expanded]="isExpanded(productCost)"
						>
							<div class="product-costs-detail">
								<div class="p-3">
									@if (isExpanded(productCost)) {
										<app-product-cost-timeline
											[costId]="productCost.id"
											[rangeStart]="rangeStart()"
											[rangeEnd]="rangeEnd()"
										/>
									}
								</div>
							</div>
						</div>
					</mat-cell>
				</ng-container>

				<mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
				<mat-row
					*matRowDef="let row; columns: displayedColumns"
					class="product-costs-data-row"
					[class.product-costs-expanded-row]="isExpanded(row)"
					(click)="toggle(row)"
				></mat-row>
				<mat-row
					*matRowDef="let row; columns: ['expandedDetail']"
					class="product-costs-detail-row"
					[class.product-costs-detail-row-expanded]="isExpanded(row)"
				></mat-row>
			</mat-table>
			@if (productCosts().length === 0) {
				<div class="alert alert-info my-1 fw-bold text-center">Brak kosztów</div>
			}
		</div>
	</div>
</div>
